import React, { useState, useRef, useEffect } from 'react';
import { Container, Col, Row, Spinner } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

import ISADgCollectionFilter from './ISADgCollectionFilter';
import ISADgCollectionTree from './ISADgCollectionTree';

import SimpleSection from '../../../components/SimpleSection';
import LoadingCollectionCard from '../../../components/LoadingCollectionCard';
import GLIFOSCollectionGridViewer from '../../../viewer/GLIFOSCollectionGridViewer';
import GLIFOSCollectionViewer from '../../../viewer/GLIFOSCollectionViewer';
import useIsInViewport from '../../../hooks/useIsInViewport';
import useIntersectionObserver from '../../../hooks/useIntersectionObserver';

export default function ISADgCollectionContent({
	isadg,
	acervo,
	apiService,
	hasHierarchyTree,
	mySelectedPhotos2,
	showMetadata,
	itemInfo,
}) {
	const [searchParams, setSearchParams] = useSearchParams();
	const [isOnTop, setIsOnTop] = useState(true);
	const selected = searchParams.get('nav');
	const [inventory, setInventory] = useState({
		isLoading: false,
		payload: {},
	});

	if (!hasHierarchyTree && selected !== isadg) {
		setSearchParams({ nav: isadg });
	}
	const galleryRef = useRef(null);
	const loadMoreRef = useRef(null);
	const [selectedPhotos, setSelectedPhotos] = useState({
		isLoading: false,
		payload: {
			collections: [],
			selected: selected,
		},
		isError: false,
		message: '',
	});
	const [displaySetup, setDisplaySetup] = useState({
		variant: isadg.includes('GT-CIRMA-FG') ? 'gallery' : 'boxes',
		perpage: 20,
	});
	const [imagePage, setImagePage] = useState(1);
	const [orderby, setOrderby] = useState({ order: 'codRef', type: 'asc' });
	const isLoadMoreInViewport = useIsInViewport(loadMoreRef.current);

	useEffect(() => {
		try {
			setSelectedPhotos((prevData) => ({
				...prevData,
				isLoading: true,
			}));
			const isSameCollection =
				selectedPhotos.payload?.selected === selected;
			if (!isSameCollection && !isOnTop) {
				/* window.scrollTo({
					top: galleryRef.current.offsetTop - 100,
					behavior: 'smooth',
				}); */
				const headerOffset = 112;
				const elementPosition = ref.current.getBoundingClientRect().top;
				const offsetPosition =
					elementPosition + window.pageYOffset - headerOffset;

				window.scrollTo({
					top: offsetPosition,
					behavior: 'smooth',
				});
			}

			const hasDifferentOrder =
				orderby.order !== selectedPhotos.payload?.currentOrder?.order ||
				orderby.type !== selectedPhotos.payload?.currentOrder?.type;
			apiService.getCollectionInfoSolr(
				{
					params: {
						repository: isadg.includes('GT-CIRMA-FG')
							? 'CIRMA-FG'
							: 'CIRMA-AH',
						isadg: selected,
						page:
							isSameCollection && !hasDifferentOrder
								? imagePage
								: 1,
						sortby: orderby.order,
						sorttype: orderby.type,
					},
				},
				{},
				(_, rdata) => {
					//console.log(rdata);
					const results = rdata?.collections
						? Array.isArray(rdata.collections)
							? rdata.collections
							: [rdata.collections]
						: [];
					setSelectedPhotos((prevData) => {
						const extraImages =
							isSameCollection && !hasDifferentOrder
								? prevData.payload.collections
								: [];
						return {
							isLoading: false,
							payload: {
								selected,
								currentOrder: orderby,
								totalResults: rdata?.result_header
									?.total_results
									? +rdata?.result_header?.total_results - 1
									: 0,
								totalPages: rdata?.result_header?.pagination
									?.total_pages
									? +rdata?.result_header?.pagination
											?.total_pages
									: 1,
								collections: [
									...extraImages,
									...results.map((collection) => {
										return {
											page: 1,
											children: selected?.includes(
												collection.id
											),

											...collection,
										};
									}),
								],
							},
						};
					});
				}
			);
		} catch (e) {
			//console.log('error en treeview', e);
			setSelectedPhotos((prevData) => ({
				...prevData,
				isLoading: false,
			}));
		}
		return () => {
			setSelectedPhotos((prevData) => ({
				...prevData,
				isLoading: false,
			}));
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selected, orderby, apiService, isadg, imagePage]);

	useEffect(() => {
		try {
			if (!itemInfo?.payload?.entity_id) return;
			setInventory({
				isLoading: true,
				payload: {},
				isError: false,
				message: '',
			});
			apiService.getInventory(
				{
					params: {
						nid: itemInfo.payload.entity_id,
					},
				},
				{},
				(_, response) => {
					console.log(response);
					if (!response.success) {
						return;
					}
					if (response?.data.file_id) {
						setInventory({
							isLoading: false,
							payload: response.data,
							isError: false,
							message: '',
						});
					}
				}
			);
		} catch (e) {
			//console.log(e);
			setInventory({
				isLoading: false,
				payload: {},
				isError: true,
				message: 'No se encontró el inventario',
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [itemInfo.payload.entity_id]);

	useEffect(() => {
		//console.log('selected', selected);
		setImagePage(1);
		const dataset = loadMoreRef.current?.dataset;
		if (dataset) {
			dataset.isloading = true;
		}
	}, [selected, orderby]);

	useEffect(() => {
		//console.log('isLoadMoreInViewport', isLoadMoreInViewport);
		const dataset = loadMoreRef.current?.dataset;
		//console.log(dataset);
		if (dataset.currentpage === dataset.totalpages) return;
		if (isLoadMoreInViewport && dataset?.isloading === 'false') {
			setImagePage((prevPage) => {
				const new_page = prevPage + 1;
				dataset.isloading = true;
				return new_page;
			});
		}
	}, [isLoadMoreInViewport]);

	const handleIntersection = (entry) => {
		if (entry.isIntersecting) {
			//console.log('Elemento visible en el viewport');
			setIsOnTop(true);
		} else {
			setIsOnTop(false);
			//console.log('Elemento no visible en el viewport');
		}
	};

	const ref = useIntersectionObserver(handleIntersection, {
		marginRoot: '112px',
	});
	return (
		<SimpleSection className='c-welcome-cirma  c-gallery-container'>
			<ISADgCollectionFilter
				orderby={orderby}
				setOrderby={setOrderby}
				displaySetup={displaySetup}
				setDisplaySetup={setDisplaySetup}
				selectedPhotos={selectedPhotos}
			/>
			<span ref={ref}></span>
			<Container className='ggridv mt-2'>
				<Row className='position-relative'>
					<ISADgCollectionTree
						isadg={isadg}
						selected={selected}
						hasHierarchyTree={hasHierarchyTree}
						collection
						showMetadata={showMetadata}
						itemInfo={itemInfo}
						inventory={inventory}
					/>
					<Col
						lg={hasHierarchyTree || showMetadata?.show ? 9 : 12}
						xs={12}
						ref={galleryRef}
					>
						<Row>
							{!selectedPhotos.isLoading &&
								selectedPhotos.payload.collections.length ===
									0 && (
									<h3 className='text-center'>
										En proceso de organización
									</h3>
								)}
							{selectedPhotos.payload.collections.length > 0 &&
							displaySetup.variant === 'gallery' ? (
								<GLIFOSCollectionViewer
									galleryRef={galleryRef}
									mySelectedPhotos={mySelectedPhotos2}
									apiService={apiService}
								/>
							) : (
								<GLIFOSCollectionGridViewer
									galleryRef={galleryRef}
									mySelectedPhotos={selectedPhotos}
									apiService={apiService}
									hasHierarchyTree={
										hasHierarchyTree || showMetadata?.show
									}
								/>
							)}
							{selectedPhotos.isLoading &&
								selectedPhotos.payload.collections.length ===
									0 &&
								new Array(displaySetup.perpage)
									.fill(0)
									.map((_, i) => (
										<LoadingCollectionCard
											key={`loading-card-collection-content-${i}`}
										/>
									))}
							<div
								className='d-flex justify-content-center'
								id='loadMore'
								ref={loadMoreRef}
								data-currentpage={imagePage}
								data-totalpages={
									selectedPhotos.payload?.totalPages ?? 1
								}
								data-isloading={selectedPhotos.isLoading}
							>
								{selectedPhotos.isLoading && (
									<Spinner animation='border' role='status'>
										<span className='visually-hidden'>
											Loading...
										</span>
									</Spinner>
								)}
							</div>
						</Row>
					</Col>
				</Row>
			</Container>
		</SimpleSection>
	);
}
